// @ts-nocheck -- will be removed once we migrate to React
import Service, { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

import window from 'ember-window-mock';

import ENV from 'receivable-invoices-js/config/environment';
import { MOLLIE_SCRIPT_ID, MOLLIE_SRC } from 'receivable-invoices-js/constants/mollie';
import { ErrorInfo } from 'receivable-invoices-js/utils/error-info';
import { loadScript } from 'receivable-invoices-js/utils/load-script';

const MOLLIE_LOCALE = {
  en: 'en_US',
  fr: 'fr_FR',
  de: 'de_DE',
  it: 'it_IT',
  es: 'es_ES',
  pt: 'pt_PT',
  nl: 'nl_NL',
};

export default class MollieService extends Service {
  @service sentry;
  @service flashMessages;
  @service intl;

  @tracked hasError = false;
  @tracked instance = null;

  async load(profileId) {
    if (this.instance || this.hasError) {
      return;
    }

    try {
      await loadScript(MOLLIE_SRC, { scriptId: MOLLIE_SCRIPT_ID });

      this.instance = window.Mollie(profileId, {
        testmode: ENV.mollie.testmode,
        locale: MOLLIE_LOCALE[this.intl.locale],
      });
    } catch (error) {
      this.hasError = true;

      if (ErrorInfo.for(error).shouldSendToSentry) {
        this.sentry.captureException(error);
      }
    }
  }

  get mount() {
    return this.instance?.mount;
  }

  get createComponent() {
    return this.instance?.createComponent;
  }

  get createToken() {
    return this.instance?.createToken;
  }

  get isLoaded() {
    return Boolean(document.querySelector(`script#${MOLLIE_SCRIPT_ID}`)) && Boolean(this.instance);
  }
}

declare module '@ember/service' {
  interface Registry {
    mollie: MollieService;
  }
}
